<h1 class="titulo">Reportes</h1>

<nz-spin [nzSpinning]="loadingReportePago" nzTip="Cargando..." class="loading-spinner">

    <div class="reporte-header">
    <div class="breadcrumb-container">
      <div class="breadcrumb-navigation">
        <span class="breadcrumb-item breadcrumb-current">Reportes</span>
        <i nz-icon nzType="right" class="breadcrumb-separator"></i>
        <span class="breadcrumb-item breadcrumb-current">Reporte de Periodo de Pago</span>
      </div>
    </div>
      
      <form [formGroup]="filtroReportePeriodoPago" *ngIf="filtroReportePeriodoPago" style="width: 100%;">
      <div class="fecha-filtros">
        <div class="fecha-grupo">
          <label class="fecha-label">Seleccionar Periodo:</label>
          <nz-select
            formControlName="periodo_seleccionado"
            nzPlaceHolder="Selecciona un periodo"
            nzShowSearch
            nzAllowClear
            class="periodo-select"
            (ngModelChange)="onPeriodoChange($event)">
            <nz-option 
              *ngFor="let periodo of periodos" 
              [nzValue]="periodo"
              [nzLabel]="formatearEtiquetaPeriodo(periodo)">
            </nz-option>
          </nz-select>
        </div>
        <div class="fecha-grupo">
          <label class="fecha-label">Fecha Inicio:</label>
          <nz-date-picker 
            formControlName="fecha_inicio"
            nzFormat="yyyy-MM-dd"
            nzPlaceHolder="Seleccionar fecha inicio"
            [nzDisabledDate]="disabledDate"
            [nzAllowClear]="false"
            class="fecha-picker"
            [nzDisabled]="true">
          </nz-date-picker>
        </div>
        <div class="fecha-grupo">
          <label class="fecha-label">Fecha Fin:</label>
          <nz-date-picker 
            formControlName="fecha_fin"
            nzFormat="yyyy-MM-dd"
            nzPlaceHolder="Seleccionar fecha fin"
            [nzDisabledDate]="disabledDate"
            [nzAllowClear]="false"
            class="fecha-picker"
            [nzDisabled]="true">
          </nz-date-picker>
        </div>
      </div>
    </form>
    </div>

    <!-- Chart Section -->
    <div class="chart-container">
      <div class="chart-wrapper">
        <canvas
          baseChart
          [data]="chartData"
          [options]="chartOptions"
          [type]="'bar'"  
          width="800"
          height="400">
        </canvas>
      </div>
    </div>
    <div class="tabla-principal">
      <div class="tabla-header-container">
        <div class="tabla-header-left">
          <span class="registros-label"
            >Registros: <strong>{{ registrosFiltrados.length }}</strong></span
          >
        </div>
        <div class="tabla-header-right">
          <!-- <nz-input-group nzSuffixIcon="search" class="search-input">
            <input 
              type="text" 
              nz-input 
              placeholder="Buscar por ID o Nombre.." 
            />
          </nz-input-group> -->
          <button 
            nz-button 
            nzType="primary" 
            class="excel-button" 
            [disabled]="generarExcel"
            nz-popover
            [nzPopoverContent]="popoverContent"
            nzPopoverPlacement="bottom"
            nzPopoverTrigger="click">
            <i nz-icon nzType="file-excel" nzTheme="outline"></i>
            Generar Excel
          </button>
          
          <ng-template #popoverContent>
            <div style="display: flex; flex-direction: column; gap: 8px; width: 260px;">
              <button 
                nz-button 
                nzType="default"
                class="excel-button"
                nzBlock
                (click)="generarExcelPeriodoPago()"
                [disabled]="generarExcel">
                <i nz-icon nzType="calendar" nzTheme="outline"></i>
                Reporte de Periodo de Pago
              </button>
              <button 
                nz-button 
                nzType="default" 
                nzBlock
                class="excel-button"
                (click)="generarExcelIncidencias()"
                [disabled]="generarExcel">
                <i nz-icon nzType="warning" nzTheme="outline"></i>
                Reporte de Incidencias
              </button>
            </div>
          </ng-template>
        </div>
      </div>
      <div class="search-container search-input-full">
        <form [formGroup]="filtroReportePeriodoPago" *ngIf="filtroReportePeriodoPago">
        <nz-input-group nzSuffixIcon="search" class="">
          <input 
            type="text" 
            nz-input 
            placeholder="Buscar por ID o Nombre.." 
            formControlName="search"
          />
        </nz-input-group>
        </form>
      </div>
      <div class="table-scroll-container">
      <nz-table
        #rowSelectionTable
        #basicTable
        [nzData]="registrosFiltrados || []"
        class="tabla-pagos tabla-compacta"
      >
        <thead>
          <tr>
            <th
            class="col-acciones"
            [nzSelections]="listOfSelection"
            [(nzChecked)]="checked"
            [nzIndeterminate]="indeterminate"
            (nzCheckedChange)="onAllChecked($event)"
          ></th>
            <!-- <th class="col-id">ID</th> -->
            <th class="col-fecha-autorizacion">Fecha Solicitud</th>
            <th class="col-estatus">Estatus</th>
            <!-- <th class="col-colaborador-id">ID Colaborador</th> -->
            <th class="col-numero-empleado">Número Empleado</th>
            <th class="col-nombre-completo">Colaborador</th>
            <th class="col-monto">Monto Autorizado</th>
            <!-- <th class="col-periodo-inicio">Período</th> -->
            <th class="col-fecha-pago">Fecha Pago</th>
            <th class="col-fecha-pago">Tipo</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of basicTable.data">
            <!-- <td class="col-id">{{ item?.id }}</td> -->
            <td
            [nzChecked]="setChecked.has(item!)"
            (nzCheckedChange)="onItemChecked(item!, $event)"
          ></td>
            <td class="col-fecha-autorizacion">
              {{ item?.fechaSolicitud }}
            </td>
            <td class="col-estatus">
              <div 
                class="estatus-container"
                [style.background-color]="getEstatusColor(item?.estatusSolicitud)"
              >
                <img 
                  [src]="getEstatusIcon(item?.estatusSolicitud)" 
                  class="estatus-icon"
                  alt="Estatus icon"
                />
                <span class="estatus-text">{{ item?.estatusSolicitud }}</span>
              </div>
            </td>
            <!-- <td class="col-colaborador-id">{{ item?.colaborador?.id }}</td> -->
            <td class="col-numero-empleado">{{ item?.numeroEmpleado }}</td>
            <td class="col-nombre-completo">
              {{ item?.nombres }} {{ item?.apellidos }}
            </td>
            <td class="col-monto">
              {{ item?.montoTotalAutorizado | currency : "MXN" : "symbol" : "1.2-2" }}
            </td>
            <!-- <td class="col-periodo-inicio">
              {{ parseDate(item?.fechaInicioPeriodo || '') | date: 'dd/MM/yyyy' }}
              -
              {{ parseDate(item?.fechaFinPeriodo || '') | date: 'dd/MM/yyyy' }}
            </td> -->
            <td class="col-fecha-pago">
              {{ (item?.fechaPago || '') | date: 'dd/MM/yyyy' }}
            </td>
            <td class="col-fecha-pago">
              {{ item?.tipoCCNominaCodigo }}
            </td>
            <!-- <td class="col-fecha-autorizacion">
              {{ parseDate(item?.fechaPago) | date: 'dd/MM/yyyy' }}
            </td> -->
          </tr>
        </tbody>
      </nz-table>
      </div>
    </div>

    </nz-spin>

    <nz-spin [nzSpinning]="loadingReporteBeneficio" nzTip="Cargando..." class="loading-spinner">
        <div class="reporte-header">
      <!-- <div class="reporte-titulo">
        Reporte de Beneficio No Ejecutado
      </div> -->
    <div class="breadcrumb-container">
      <div class="breadcrumb-navigation">
        <span class="breadcrumb-item breadcrumb-current">Reportes</span>
        <i nz-icon nzType="right" class="breadcrumb-separator"></i>
        <span class="breadcrumb-item breadcrumb-current">Reporte de Beneficio No Ejecutado</span>
      </div>
    </div>
    </div>

    <!-- Top 10 Chart Section -->
    <div class="chart-container">
      <div class="chart-wrapper">
        <canvas
          baseChart
          [data]="ChartData2"
          [options]="ChartOptions2"
          [type]="'line'"
          width="800"
          height="500">
        </canvas>
      </div>
    </div>
    <div class="tabla-principal">
      <div class="tabla-header-container">
        <div class="tabla-header-left">
          <span class="registros-label"
            >Registros: <strong>{{ registros_colaboradores_filtrados.length }}</strong></span
          >
        </div>
        <div class="tabla-header-right">
          <button nz-button nzType="primary" class="excel-button" (click)="generarExcelBeneficioNoEjecutado()" [disabled]="generarExcel">
            <i nz-icon nzType="file-excel" nzTheme="outline"></i>
            Generar Excel
          </button>
        </div>
      </div>

      <div class="search-container search-input-full">
        <nz-input-group nzSuffixIcon="search" class="">
          <input 
            type="text" 
            nz-input 
            placeholder="Buscar por ID o Nombre.." 
            [(ngModel)]="searchText"
            (ngModelChange)="filtradoNombre($event)"
          />
        </nz-input-group>
      </div>

      <div class="table-scroll-container">
      <nz-table
        #basicTable2
        [nzData]="registros_colaboradores_filtrados || []"
        class="tabla-pagos tabla-compacta"
      >
        <thead>
          <tr>
            <!-- <th class="col-id">ID</th> -->
            <th class="col-fecha-autorizacion">Número de Empleado</th>
            <!-- <th class="col-colaborador-id">ID Colaborador</th> -->
            <th class="col-nombre-completo">Colaborador</th>
            <th class="col-nombre-completo">Fecha de Nacimiento</th>
            <th class="col-numero-empleado">Division</th>
            <th class="col-numero-empleado">Sociedad</th>
            <th class="col-monto">Saldo Pendiente</th>
            <th class="col-monto">Saldo Total Anual</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of basicTable2.data">
            <!-- <td class="col-id">{{ item?.id }}</td> -->
            <td class="col-fecha-autorizacion">
              {{ item?.numeroEmpleado }}
            </td>
            <!-- <td class="col-colaborador-id">{{ item?.colaborador?.id }}</td> -->
            <td class="col-numero-empleado">
              {{ item?.nombres }} {{ item?.apellidos }}
            </td>
            <td class="col-numero-empleado">
              {{ item?.fechaNacimiento | date: 'dd/MM/yyyy' }}
            </td>
            <td class="col-sociedad-division">
              {{ item?.divisionNombre }}
            </td>
            <td class="col-numero-empleado">
              {{ item?.sociedadNombre }}
            </td>
            <td class="col-saldo-total">
              {{ item?.saldoRestante | currency : "MXN" : "symbol" : "1.2-2" }}
            </td>
            <td class="col-saldo-total">
              {{ item?.saldoTotal | currency : "MXN" : "symbol" : "1.2-2" }}
            </td>
          </tr>
        </tbody>
      </nz-table>
      </div>
    </div>
    </nz-spin>
  <nz-modal [(nzVisible)]="isVisible" nzTitle="" (nzOnCancel)="handle()" [nzWidth]="400" [nzCentered]="true">
    <div *nzModalContent>
      <div class="modal-content-small">
        <div class="warning-container-horizontal">
          <i nz-icon nzType="exclamation-circle" nzTheme="outline" class="warning-icon-small"></i>
          <span class="warning-text-small">Debes seleccionar al menos un registro</span>
        </div>
      </div>
    </div>
      <div *nzModalFooter>
        <button nz-button nzType="primary" nzDanger class="modal-button-small" (click)="handle()">Aceptar</button>
      </div>
    </nz-modal>